export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200 pt-16 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <span className="font-heading text-2xl text-background-50 mb-4 block">樱花漫画</span>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              韩漫日漫国漫漫画大全，免费全集下拉式阅读平台。好看的漫画在线推荐，追更连载收藏一站搞定。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-arrow-up-line text-background-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '热门话题', href: '#topics' },
                { label: '专题合集', href: '#index' },
                { label: '排行榜', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <div className="space-y-2.5">
              {['韩漫推荐', '日漫经典', '国漫精选', '恋爱漫画', '热血战斗', '悬疑推理', '搞笑日常'].map((cat) => (
                <a key={cat} href="#index" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 mb-4">合作伙伴信息即将上线，敬请期待。</p>
            <h4 className="text-sm font-semibold text-background-50 mb-3 mt-6">关注我们</h4>
            <div className="flex items-center gap-2">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-bilibili-line', label: 'B站' },
                { icon: 'ri-live-line', label: '抖音' },
              ].map((social) => (
                <div key={social.label} className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                  <i className={`${social.icon} text-background-200`}></i>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 樱花漫画网 · 韩漫日漫国漫免费在线漫画阅读平台 · 下拉式阅读
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>服务条款</span>
            <span>隐私政策</span>
            <span>版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}